define("shared/components/shared/post/secondary/caption-writer/credit-plan-details", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@glimmer/component", "lodash"], function (_exports, _component, _templateFactory, _service, _component2, _lodash) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"lodash"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    class={{concat-classes
      "tCW--card tCW--card--advanced u--m__tb__md"
      (concat "qa--upgradeCardPlan--" (lowercase @subscriptionPlan.planType))
    }}
    data-test-id="credit-plan-details"
    data-test-target-plan-type={{@subscriptionPlan.planType}}
  >
    <h3 class="u--text--base u--text--bold u--m__0">
      {{t "caption_writer.credit_purchase.section_title.upgrade_plan"}}
    </h3>
    <p class="u--text--sm u--text--light u--m__t__xs u--m__b__0">
      {{#if this.isPaid}}
        {{t "caption_writer.credit_purchase.section_title.description"}}
      {{else}}
        {{t "caption_writer.credit_purchase.section_title.free_description"}}
      {{/if}}
    </p>
    <hr class="u--m__tb__xs" />
    <p class="tCW--card__hl">
      <span class={{concat "u--text--bold cMH--upgradeCardPlan--" (lowercase @subscriptionPlan.planType)}}>
        {{t "caption_writer.credit_purchase.plan_header" planName=@subscriptionPlan.displayName}}
      </span>
      <span class="u--text--base u--text--black">{{this.formattedPrice}}</span>
    </p>
    <ul class="tCW--cardList">
      <li class="tCW--cardList__li">
        {{svg-jar "verified" class="o--icon o--icon--success"}}
        <span>
          {{html-safe (t "caption_writer.credit_purchase.plan_credits" count=@subscriptionPlan.numberOfAiCredits)}}
        </span>
      </li>
      <li class="tCW--cardList__li">
        {{svg-jar "verified" class="o--icon o--icon--success"}}
        <span>{{t "caption_writer.credit_purchase.credits_addon_price"}}</span>
      </li>
      <li class="tCW--cardList__li">
        {{svg-jar "verified" class="o--icon o--icon--success"}}
        <span>
          {{t
            "caption_writer.credit_purchase.plan_addons"
            socialSets=@subscriptionPlan.numberOfSocialSets
            users=@subscriptionPlan.numberOfUsers
          }}
        </span>
      </li>
      <li class="tCW--cardList__li">
        {{svg-jar "verified" class="o--icon o--icon--success"}}
        <span>{{this.formattedPosts}}</span>
        <Shared::Ui::Button
          @class="u--text--sm u--text--uppercase u--m__l__sm"
          @variant="actionLink"
          {{on "click" (toggle-action "showAllFeaturesModal" this)}}
        >
          {{t "plans.see_all_features"}}
        </Shared::Ui::Button>
      </li>
    </ul>
    <Shared::Button::Upgrade
      @additional="block"
      @confirmLeave={{true}}
      @feature={{this.captionWriterFeature}}
      @location="caption_writer"
      @seamlessCheckoutSuccessCallback={{@onSeamlessCheckoutSuccess}}
      class={{this.qaClass}}
    />
  </div>
  
  {{#if this.showAllFeaturesModal}}
    <Shared::Portal @destinationElement="root-portal">
      <Shared::Upgrade::AllFeaturesModal
        @close={{toggle-action "showAllFeaturesModal" this}}
        @focusTrap={{true}}
        @isMonthly={{true}}
        @planType={{@subscriptionPlan.planType}}
      />
    </Shared::Portal>
  {{/if}}
  */
  {
    "id": "nXgh2thf",
    "block": "[[[10,0],[15,0,[28,[37,0],[\"tCW--card tCW--card--advanced u--m__tb__md\",[28,[37,1],[\"qa--upgradeCardPlan--\",[28,[37,2],[[30,1,[\"planType\"]]],null]],null]],null]],[14,\"data-test-id\",\"credit-plan-details\"],[15,\"data-test-target-plan-type\",[30,1,[\"planType\"]]],[12],[1,\"\\n  \"],[10,\"h3\"],[14,0,\"u--text--base u--text--bold u--m__0\"],[12],[1,\"\\n    \"],[1,[28,[35,3],[\"caption_writer.credit_purchase.section_title.upgrade_plan\"],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,2],[14,0,\"u--text--sm u--text--light u--m__t__xs u--m__b__0\"],[12],[1,\"\\n\"],[41,[30,0,[\"isPaid\"]],[[[1,\"      \"],[1,[28,[35,3],[\"caption_writer.credit_purchase.section_title.description\"],null]],[1,\"\\n\"]],[]],[[[1,\"      \"],[1,[28,[35,3],[\"caption_writer.credit_purchase.section_title.free_description\"],null]],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n  \"],[10,\"hr\"],[14,0,\"u--m__tb__xs\"],[12],[13],[1,\"\\n  \"],[10,2],[14,0,\"tCW--card__hl\"],[12],[1,\"\\n    \"],[10,1],[15,0,[28,[37,1],[\"u--text--bold cMH--upgradeCardPlan--\",[28,[37,2],[[30,1,[\"planType\"]]],null]],null]],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"caption_writer.credit_purchase.plan_header\"],[[\"planName\"],[[30,1,[\"displayName\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[14,0,\"u--text--base u--text--black\"],[12],[1,[30,0,[\"formattedPrice\"]]],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"ul\"],[14,0,\"tCW--cardList\"],[12],[1,\"\\n    \"],[10,\"li\"],[14,0,\"tCW--cardList__li\"],[12],[1,\"\\n      \"],[1,[28,[35,5],[\"verified\"],[[\"class\"],[\"o--icon o--icon--success\"]]]],[1,\"\\n      \"],[10,1],[12],[1,\"\\n        \"],[1,[28,[35,6],[[28,[37,3],[\"caption_writer.credit_purchase.plan_credits\"],[[\"count\"],[[30,1,[\"numberOfAiCredits\"]]]]]],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"li\"],[14,0,\"tCW--cardList__li\"],[12],[1,\"\\n      \"],[1,[28,[35,5],[\"verified\"],[[\"class\"],[\"o--icon o--icon--success\"]]]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,3],[\"caption_writer.credit_purchase.credits_addon_price\"],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"li\"],[14,0,\"tCW--cardList__li\"],[12],[1,\"\\n      \"],[1,[28,[35,5],[\"verified\"],[[\"class\"],[\"o--icon o--icon--success\"]]]],[1,\"\\n      \"],[10,1],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"caption_writer.credit_purchase.plan_addons\"],[[\"socialSets\",\"users\"],[[30,1,[\"numberOfSocialSets\"]],[30,1,[\"numberOfUsers\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"li\"],[14,0,\"tCW--cardList__li\"],[12],[1,\"\\n      \"],[1,[28,[35,5],[\"verified\"],[[\"class\"],[\"o--icon o--icon--success\"]]]],[1,\"\\n      \"],[10,1],[12],[1,[30,0,[\"formattedPosts\"]]],[13],[1,\"\\n      \"],[8,[39,7],[[4,[38,8],[\"click\",[28,[37,9],[\"showAllFeaturesModal\",[30,0]],null]],null]],[[\"@class\",\"@variant\"],[\"u--text--sm u--text--uppercase u--m__l__sm\",\"actionLink\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"plans.see_all_features\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[8,[39,10],[[16,0,[30,0,[\"qaClass\"]]]],[[\"@additional\",\"@confirmLeave\",\"@feature\",\"@location\",\"@seamlessCheckoutSuccessCallback\"],[\"block\",true,[30,0,[\"captionWriterFeature\"]],\"caption_writer\",[30,2]]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showAllFeaturesModal\"]],[[[1,\"  \"],[8,[39,11],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,12],null,[[\"@close\",\"@focusTrap\",\"@isMonthly\",\"@planType\"],[[28,[37,9],[\"showAllFeaturesModal\",[30,0]],null],true,true,[30,1,[\"planType\"]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[\"@subscriptionPlan\",\"@onSeamlessCheckoutSuccess\"],false,[\"concat-classes\",\"concat\",\"lowercase\",\"t\",\"if\",\"svg-jar\",\"html-safe\",\"shared/ui/button\",\"on\",\"toggle-action\",\"shared/button/upgrade\",\"shared/portal\",\"shared/upgrade/all-features-modal\"]]",
    "moduleName": "shared/components/shared/post/secondary/caption-writer/credit-plan-details.hbs",
    "isStrictMode": false
  });

  let CreditPlanDetailsComponent = (_class = class CreditPlanDetailsComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _initializerDefineProperty(this, "locale", _descriptor3, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor4, this);

      _defineProperty(this, "qaClass", void 0);

      const planName = (0, _lodash.capitalize)(this.args.subscriptionPlan?.planType);
      this.qaClass = `qa--upgradeTo${planName}_button`;
    }

    get capitalizedPlanType() {
      const planName = this.args.subscriptionPlan?.planType ?? this.args.planName ?? '';
      return `${planName.charAt(0).toUpperCase()}${planName.slice(1)}`;
    }

    get currentPlanType() {
      return this.subscriptions.planType;
    }

    get captionWriterFeature() {
      if (this.currentPlanType === 'free' || this.auth.currentAccount.isOnLegacyPlan) {
        return `aiCaptionWriter${this.capitalizedPlanType}FromFree`;
      }

      return `aiCaptionWriter${this.capitalizedPlanType}`;
    }

    get formattedPosts() {
      const postCount = this.args.subscriptionPlan?.numberOfPosts ?? 0;
      return postCount < 0 ? this.intl.t('caption_writer.credit_purchase.plan_unlimited_posts') : this.intl.t('caption_writer.credit_purchase.plan_posts', {
        postCount
      });
    }

    get formattedPrice() {
      const price = this.locale.formatCurrency(((this.args.subscriptionPlan?.amount ?? 0) / 100).toFixed(0), 'USD', {
        trailingZeroDisplay: 'stripIfInteger'
      });

      if (this.args.subscriptionPlan?.isMonthly) {
        return this.intl.t('caption_writer.credit_purchase.plan_price_monthly', {
          price
        });
      }

      return this.intl.t('caption_writer.credit_purchase.plan_price_yearly', {
        price
      });
    }

    get isPaid() {
      return this.subscriptions.isPaid;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = CreditPlanDetailsComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CreditPlanDetailsComponent);
});